var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item"},[_c('img',{staticClass:"item-img",attrs:{"src":require("../img/img/m1.jpg")}}),_c('img',{staticClass:"item-img",attrs:{"src":require("../img/img/m2.jpg")}}),_c('img',{staticClass:"item-img",attrs:{"src":require("../img/img/m3.jpg")}}),_c('img',{staticClass:"item-img",attrs:{"src":require("../img/img/m4.jpg")}})])])
}]

export { render, staticRenderFns }